import { createHead } from '@unhead/vue/client';
import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'

//localization
import primeFr from '@/locale/primevue-fr.json';

//fontawesome
import "@/assets/fontawesome/css/all.min.css";

//PrimeVue
import PrimeVue from 'primevue/config';
import 'primeicons/primeicons.css';
import './assets/main.css';




//Private Components
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Checkbox from 'primevue/checkbox';
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';
import Password from 'primevue/password';
import ProgressSpinner from 'primevue/progressspinner';
import Dialog from 'primevue/dialog';
import Tooltip from 'primevue/tooltip';
import Menubar from 'primevue/menubar';
import InlineMessage from 'primevue/inlinemessage';

//Directives
import BadgeDirective from 'primevue/badgedirective';

import { checkLoggedIn, isLoggedIn, isAdmin, checkIsAdmin } from './services/AuthService';

const app = createApp(App)
const head = createHead();
app.use(createPinia())


app.component('Button', Button);
app.component('Calendar', Calendar);
app.component('Checkbox', Checkbox);
app.component('InputText', InputText);
app.component('Textarea', Textarea);
app.component('Password', Password);
app.component('ProgressSpinner', ProgressSpinner);
app.component('Dialog', Dialog);
app.component('Menubar', Menubar);
app.component('InlineMessage', InlineMessage);


app.directive('badge', BadgeDirective);
app.directive('tooltip', Tooltip);

//PrimeComponents
app.use(PrimeVue, {
    locale: primeFr,
    zIndex: {
        modal: 100,     // Dialog
        overlay: 110,   // Dropdown, overlay panel etc.
        menu: 300,      // Menus
        tooltip: 1100,   // Tooltip
        toast: 1200,     // Toast
      }
});



app.use(router);
app.use(head);

router.beforeEach(async (to, from, next) => {

    isLoggedIn.value = await checkLoggedIn();
    isAdmin.value = await checkIsAdmin();

    if (to.meta.requiresAuth && !isLoggedIn.value) {
        // next('/login');
        next({ path: '/login', query: { redirect: to.fullPath } });
    } else if (to.meta.isAdmin && !isAdmin.value) {
        if (isLoggedIn.value)
            next('/dashboard');
        else
            next('/login');
    } else {
        next();
    }
});

app.config.errorHandler = (err) => {
    /* gérer l'erreur */
    console.log(err);
}

app.mount('#app')
